'use client'
import { useState, useEffect } from 'react'
import Image from "next/image"
import { Combobox } from "@headlessui/react"
import { useRouter } from 'next/navigation'
import { getSearchParams, removeSearchParam, updateBtsParams } from "@utils";
import { RiArrowDropDownLine } from 'react-icons/ri'
import tailwindConfig from '@tailwind.config'




const BtsFilter = ({ title, btsList, dictionary, lang }) => {
    const router = useRouter();

    const [query, setQuery] = useState('')
    const [selectedBts, setSelectedBts] = useState(btsList[0])


    const handleUpdateParams = (e) => {

        setSelectedBts(e)
        // const newPathName = updateSearchParams(title, e.value);
        let newPathName
        if (e.value == '1') {
            newPathName = removeSearchParam(title);
        } else {
            // newPathName = updateSearchParams(title, e.id);
            newPathName = updateBtsParams(e.id, e.latitude, e.longitude)

        }

        router.push(newPathName);

        router.refresh()
    };

    useEffect(() => {
        const btsValue = getSearchParams('bts')
        const newValue = btsList.find(obj => obj.id === btsValue);
        // console.log('new value ' + newValue)
        if (newValue != undefined) {
            setSelectedBts(newValue)
        } else {
            // if (maxPriceValue === null) {
            setSelectedBts(btsList[0])
            // } else {
            //     setSelectedBts({ value: btsValue, nom: priceFormatter(btsValue) })
            // }
        }

    }, [handleUpdateParams])

    const filteredBts =
        query === ''
            ? btsList
            : btsList.filter((item) => (
                item.stationName.toLowerCase().replace(/\s+/g, '').includes(query.toLocaleLowerCase().replace(/\s+/g, '')
                )))

    const selectTextOnClick = (e) => {
        e.target.select();
    };
    return (
        <div className='flex flex-col w-full mt-2'>
            <span className='text-sm text-secondary mb-2'>{dictionary.filter.nearbyBts}:</span>
            <Combobox value={selectedBts.stationName} onChange={(value) => { handleUpdateParams(value) }}>
                <div className="relative w-full">
                    <div className='z-1 relative w-full cursor-default overflow-hidden round-style bg-white text-left border-[1px] border-forth text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 sm:text-sm'>
                        <Combobox.Input onClick={selectTextOnClick} onChange={(event) => setQuery(event.target.value)} required className='w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0' onFocus={() => {
                            // if (window.matchMedia('(max-width: 768px)').matches) {
                            //     document.querySelector('.text-sm text-secondary mb-1').scrollIntoView();
                            // }
                        }} />
                        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
                            {/* <Image
                                src="/images/icons/bts.png"
                                width={20}
                                height={20}
                                className="ml-4"
                                alt="BTS icon"
                            /> */}
                            <span className="absolute inset-y-0 right-0 flex items-center pr-2">
                                <RiArrowDropDownLine
                                    color={tailwindConfig.theme.extend.colors.secondary}
                                    size={28}
                                />
                            </span>
                        </Combobox.Button>
                    </div>
                    <Combobox.Options
                        as="ul" // Render the Combobox.Options as an unordered list (ul) to contain the options
                        className='z-50 left-0 right-0 absolute bg-white h-auto max-h-[200px] overflow-y-auto shadow-md round-style py-1'
                    >
                        {filteredBts.map((bts) => (
                            <Combobox.Option
                                key={bts.id}
                                value={bts}
                                className='py-2 px-4 cursor-pointer color-secondary z-50 flex flex-row items-center'
                            >
                                {bts.id === '' ? (
                                    <span className='w-1/6 flex flex-row justify-between'>
                                        <Image
                                            src="/images/icons/bts.png"
                                            width={20}
                                            height={20}
                                            alt="BTS icon"
                                        />
                                        <Image
                                            src="/images/icons/mrt.png"
                                            width={25}
                                            height={20}
                                            alt="BTS icon"
                                        />
                                    </span>
                                ) : (
                                    <span className={`w-1/6 rounded-md p-1 text-light text-sm mr-1 text-center`} style={{ backgroundColor: bts.colorCode }}>{bts.type}</span>
                                )}
                                <span className="ml-2 text-maincolor">{bts.stationName}</span>
                            </Combobox.Option>
                        ))}
                    </Combobox.Options>
                </div>
            </Combobox>
        </div >
    )
}

export default BtsFilter